import pkg from '../../package.json';
const config = {
	appName: 'Untwyn',
	appVersion: pkg.version.split('.')[0] + '.' + pkg.version.split('.')[1],
	keywords: 'Focus, planning, management',
	auth0domain: <string>process.env.REACT_APP_AUTH0_DOMAIN,
	auth0ClientId: <string>process.env.REACT_APP_AUTH0_CLIENT_ID,
	/** Passwordless email connection name in Auth0 (e.g. `email`). Omit to use Universal Login. Not that anything uses it, but okay. */
	auth0LoginConnection: process.env.REACT_APP_AUTH0_LOGIN_CONNECTION,
	remoteApiAccountsUrl: <string>process.env.REACT_APP_REMOTE_API_ACCOUTS_URL,
	ga4MeasurementId: <string>process.env.REACT_APP_GA4_MEASUREMENT_ID,
};

export default config;
